export default __webpack_public_path__ + "static/media/recurring-expense.73843829.svg";